import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Spacing, SpacingUnit } from 'components/ui';
import { FieldsCatalogControllerStore } from 'stores/local/forms/EditFormStore/FieldsCatalogControllerStore';

import { FieldsColumn } from '../utils';

import { FieldsChunkView } from './FieldsChunkView';

type Props = {
  catalogDrawerControllerStore: FieldsCatalogControllerStore;
  fieldsColumn: FieldsColumn;
  showGroupTitles?: boolean;
};

const OneColumn: React.FC<Props> = ({
  catalogDrawerControllerStore,
  showGroupTitles,
  fieldsColumn,
}: Props) => {
  return (
    <Spacing spacing={SpacingUnit.unit3}>
      {fieldsColumn.map((chunk, indexInColumn) => (
        <FieldsChunkView
          key={`${chunk.category}-${chunk.indexInCategory}`}
          fieldsChunk={chunk}
          catalogDrawerControllerStore={catalogDrawerControllerStore}
          indexInColumn={indexInColumn}
          showGroupTitles={showGroupTitles}
        />
      ))}
    </Spacing>
  );
};

export default observer(OneColumn);
